import SettingsForm from "../components/SettingsForm";
import Api from "../common/Api";
import {message} from "antd";
import {AxiosError} from "axios";
import {useNavigate} from "react-router-dom";
import {useState} from "react";

const Settings = () => {
    const [spinning, setSpinning] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        setSpinning(true);
        try {
            await Api.management.updatePassword(
                values.currentPassword,
                values.newPassword
            )
            navigate('/', {replace: true})
            message.success("Password successfully updated!")
        } catch (e) {
            if (e instanceof AxiosError) {
                const error = e as AxiosError;
                return message.error(error.response?.data as string);
            }
            message.error('Unknown error')
        } finally {
            setSpinning(false)
        }
    };

    const onFinishFailed = async (errorInfo: any) => {

        console.log('Failed:', errorInfo);
    };

    return (
        <>
            <h3>Change your password</h3>
            <SettingsForm onFinish={onFinish} onFinishFailed={onFinishFailed} spinning={spinning}/>
        </>
    )
}

export default Settings;
